<template>
    <div class="flex text-white justify-center">
        <p> <a
            ></a>
            &copy; 2023-{{ thisYear }}, Cloudamai LLC
        </p>
        <a href="/terms-of-service" class=" pl-2 underline">Terms Of Use</a>
    </div>
</template>

<script setup lang="ts">
const VERSION = import.meta.env.VITE_APP_VERSION
const BUILD_DATE = import.meta.env.VITE_APP_BUILD_EPOCH
    ? new Date(Number(import.meta.env.VITE_APP_BUILD_EPOCH))
    : undefined
const thisYear = new Date().getFullYear()
</script>
